<template>

<div :class="{'hide': loading}" style="overflow: hidden;">
<div :class="{'spinner loading': loading}"></div>

	<div class="form-box-items">
		<!-- FORM BOX ITEM -->
		<div class="form-box-item full">
				<!-- PROFILE IMAGE UPLOAD -->
				<div class="profile-image">
					<div class="profile-image-data">
						<figure class="user-avatar medium">
							<img :src="avatar" alt="profile-default-image" style="width: 70px; height: 70px;">
						</figure>
						<p v-if="!$user.isWriter()" class="text-header">Profile Photo</p>
						<p v-if="$user.isWriter()" class="text-header">{{person.name}}</p>
						<p v-if="!$user.isWriter()" class="upload-details">Maximum size - 5 Mb.</p>
						<p v-if="errors.avatar" class="error" >{{errors.avatar[0]}}</p>
						<a v-if="$user.isAdmin() && person.id != $user.id()" :href="'/admin/actions/user/'+person.id+'/impersonate'">Impersonate</a>

					</div>
					<input v-if="!$user.isWriter()" class="input-file" id="avatar" name="avatar" @change="onFileSelected" type="file" style="display: none">
					<label v-if="!$user.isWriter()" tabindex="0" for="avatar" class="button mid-short primary input-file-trigger">Select a file...</label>
					<p class="file-return"></p>
				</div>
				<!-- PROFILE IMAGE UPLOAD -->

				<h4>Profile information</h4>
				<hr class="line-separator">

				<div class="input-container">
					<div class="order-form-heading">
						<label for="name" class="rl-label">Account Name</label>
					</div>
					<div class="order-form-body">
						<input
								name="name"
								type="text"
								:class="{ 'error': $v.name.$error }"
								@blur="$v.name.$touch()"
								ref='name'
								v-model="name"
								:readonly="!$user.isAdmin()">

						<p class="error" v-if="errors.name">{{errors.name[0]}}</p>
					</div>

				</div>

				<div class="input-container" v-if="!$user.isWriter()">
					<div class="order-form-heading">
						<label for="email" class="rl-label">Email address</label>
					</div>
					<div class="order-form-body">
						<input name="email"
							   type="text"
							   :class="{ 'error': $v.email.$error }"
							   @blur="$v.email.$touch()"
							   ref='email'
							   v-model="email"
							   :readonly="!$user.isAdmin()">
						<p class="error" v-if="errors.email">{{errors.email[0]}}</p>

					</div>
				</div>

				<div v-if="person.role == 1" class="input-container">
					<div class="order-form-heading">
						<label for="major" class="rl-label">What is your Major?</label>
					</div>
					<div class="order-form-body">
						<input
								name="major"
								id="major"
								type="text"
								:class="{ 'error': $v.major.$error }"
								@blur="$v.major.$touch()"
								ref='major'
								v-model="major"
								:readonly="$user.isWriter()"
								maxlength="100"
								placeholder="For example, Business Studies">
						<p class="error" v-if="errors.major">{{errors.major[0]}}</p>

					</div>
				</div>

				<div v-if="person.role == 1" class="input-container">
					<div class="order-form-heading">
						<label for="title" class="rl-label">What is your degree?</label>
					</div>
					<div class="order-form-body">
						<label for="degree" class="select-block">
							<select name="degree" id="degree" v-model="degree">
								<option :disabled="$user.isWriter()"
										ref='degree'
										v-for="degree in degrees"
										v-bind:value="degree.value">
									{{ degree.text }}
								</option>
							</select>
							<!-- SVG ARROW -->
							<svg class="svg-arrow">
								<use xlink:href="#svg-arrow"></use>
							</svg>
							<!-- /SVG ARROW -->
						</label>
					</div>
				</div>

				<div v-if="person.role == 1" class="input-container">
					<div class="order-form-heading">
						<label for="first_language" class="rl-label">English is my:</label>
					</div>
					<div class="order-form-body">
						<label for="first_language" class="select-block">
							<select name="first_language" id="first_language" v-model="language">
								<option :disabled="$user.isWriter()"
										ref='language'
										v-for="language in languages"
										v-bind:value="language.value">
									{{ language.text }}
								</option>
							</select>
							<!-- SVG ARROW -->
							<svg class="svg-arrow">
								<use xlink:href="#svg-arrow"></use>
							</svg>
							<!-- /SVG ARROW -->
						</label>
					</div>
				</div>

				<div v-if="person.role_name == 'customer'" class="input-container">
					<div class="order-form-heading">
						<label for="comment" class="rl-label">Comments for Writers:</label>
					</div>
					<div class="order-form-body">
						<textarea :readonly="$user.isWriter()"
								  id="comment"
								  :class="{ 'error': $v.comment.$error }"
								  @blur="$v.comment.$touch()"
								  ref='comment'
								  v-model="comment"
								  :placeholder="$user.isWriter() ? '' : 'You may type some comments for writers here...'"
								  name="comment"
								  cols="50"
								  rows="10"
								  maxlength="2500"></textarea>
						<p class="error" v-if="errors.comment">{{errors.comment[0]}}</p>

					</div>
				</div>

				<div v-if="$user.isAdmin() && person.id !== $user.id()" class="input-container">
					<div class="order-form-heading">
						<label for="comment_from_support_to_writers" class="rl-label">Comments for Writers From Support:</label>
					</div>
					<div class="order-form-body">
						<textarea :readonly="$user.isWriter()"
								  id="comment_from_support_to_writers"
								  :class="{ 'error': $v.comment_from_support_to_writers.$error }"
								  @blur="$v.comment_from_support_to_writers.$touch()"
								  ref='comment_from_support_to_writers'
								  v-model="comment_from_support_to_writers"
								  name="comment_from_support_to_writers"
								  cols="50"
								  rows="10"
								  maxlength="5000"></textarea>
						<p class="error" v-if="errors.comment_from_support_to_writers">{{errors.comment_from_support_to_writers[0]}}</p>

					</div>
				</div>




			<div v-if="$user.isAdmin() && person.id != $user.id()">
			<h4>Test user</h4>
			<hr class="line-separator">
			<div class="input-container">
				<div class="order-form-heading">
					<label for="test" class="rl-label">Tester</label>
				</div>
				<div class="order-form-body">
					<label for="test" class="select-block">
						<select name="first_language" id="test" v-model="test">
							<option v-for="test in testOptions"
									v-bind:value="test.value">
								{{ test.text }}
							</option>
						</select>

						<!-- SVG ARROW -->
						<svg class="svg-arrow">
							<use xlink:href="#svg-arrow"></use>
						</svg>
						<!-- /SVG ARROW -->
					</label>
				</div>
			</div>




			<div v-if="$user.isAdmin()">
			<h4>Status</h4>
			<hr class="line-separator">
			<div class="input-container">
				<div class="order-form-heading">
					<label for="status" class="rl-label">Status</label>
				</div>
				<div class="order-form-body">
					<label for="status" class="select-block">
						<select name="status" id="status" v-model="status">
							<option v-for="status in statusOptions"
									v-bind:value="status.value">
								{{ status.text }}
							</option>
						</select>

						<!-- SVG ARROW -->
						<svg class="svg-arrow">
							<use xlink:href="#svg-arrow"></use>
						</svg>
						<!-- /SVG ARROW -->
					</label>
				</div>
			</div>
			</div>

			<h4>Discount</h4>
			<hr class="line-separator">
			<div class="input-container">
					<div class="order-form-heading">
						<label for="test" class="rl-label">Discount (%)</label>
					</div>
					<div class="order-form-body">
						<label for="discount" class="select-block">
							<input
									name="discount"
									id="discount"
									type="number"
									v-model="discount"
									min="0"
									max="50"
									placeholder="from 0 to 50%">

						</label>
					</div>
				</div>

				<h4>Settings</h4>
				<hr class="line-separator">
				<div class="input-container">
					<div class="order-form-heading">
						<label for="test" class="rl-label">Disable Autotake</label>
					</div>
					<div class="order-form-body">
						<label for="disable_autotake" class="select-block">
							<select name="disable_autotake" id="disable_autotake" v-model="disable_autotake">
								<option v-for="option in disableAutotakeOptions"
										v-bind:value="option.value">
									{{ option.text }}
								</option>
							</select>

							<!-- SVG ARROW -->
							<svg class="svg-arrow">
								<use xlink:href="#svg-arrow"></use>
							</svg>
							<!-- /SVG ARROW -->
						</label>
					</div>
				</div>

				<div class="input-container">
					<div class="order-form-heading">
						<label for="disable_editing" class="rl-label">Disable Editing</label>
					</div>
					<div class="order-form-body">
						<label for="disable_editing" class="select-block">
							<select name="disable_editing" id="disable_editing" v-model="disable_editing">
								<option v-for="option in disableEditingOptions"
										v-bind:value="option.value">
									{{ option.text }}
								</option>
							</select>

							<!-- SVG ARROW -->
							<svg class="svg-arrow">
								<use xlink:href="#svg-arrow"></use>
							</svg>
							<!-- /SVG ARROW -->
						</label>
					</div>
				</div>

				<hr class="line-separator">

			</div>


			<div v-if="!$user.isWriter()" >
					<h4>Change password</h4>
					<hr class="line-separator">

					<div v-if="!$user.isAdmin() || ($user.isAdmin() && person.id == $user.id()) " class="input-container">
						<div class="order-form-heading">
							<label for="current_password" class="rl-label">Current Password</label>
						</div>

						<div class="order-form-body">
							<input
									id="current_password"
									type="password"
									v-model="currentPassword"
									:class="{ 'error': $v.currentPassword.$error }"
									@blur="$v.currentPassword.$touch()"
									ref='currentPassword'
									class="form-control"
									name="current_password">
							<p class="error" v-if="errors.current_password">{{errors.current_password}}</p>

						</div>
					</div>

					<div class="input-container">
						<div class="order-form-heading">
							<label for="new_password" class="rl-label">New Password</label>
						</div>

						<div class="order-form-body">
							<input id="new_password"
								   v-model="newPassword"
								   :class="{ 'error': $v.newPassword.$error }"
								   @blur="$v.newPassword.$touch()"
								   ref='newPassword'
								   type="password"
								   class="form-control"
								   name="new_password">
							<p class="error" v-if="errors.new_password">{{errors.new_password[0]}}</p>
						</div>
					</div>

					<div class="input-container">
						<div class="order-form-heading">
							<label for="new-password-confirm" class="rl-label">Confirm New Password</label>
						</div>
						<div class="order-form-body">
							<input id="new-password-confirm"
								   type="password"
								   v-model="newPasswordConfirmation"
								   :class="{ 'error': $v.newPasswordConfirmation.$error }"
								   @blur="$v.newPasswordConfirmation.$touch()"
								   ref='newPasswordConfirmation'
								   class="form-control"
								   name="new-password_confirmation">
						</div>
					</div>

					<button @click="validate" class="button mid primary" name="submit-button">Save changes</button>
				</div>

		</div>
		<!-- /FORM BOX ITEM -->

	</div>


</div>
</template>


<script>

    import { required, email, minLength, maxLength, sameAs, requiredIf, between } from 'vuelidate/lib/validators'


    export default {
        props: ['person'],

        data() {
            return {

                name: '',
            	email: '',
            	major: '',
            	degree: false,
                language: false,
                comment: '',
                comment_from_support_to_writers: '',
				test: 0,
                discount: 0,
                disable_autotake: 0,
                disable_editing: 0,
				status: 1,

                currentPassword: '',
                newPassword: '',
                newPasswordConfirmation: '',


                image: null,
				avatar: '/images/avatars/'+this.person.avatar,


                degrees: [
                    { text: 'School', value: 1 },
                    { text: 'College', value: 2 },
                    { text: 'Bachelor\'s', value: 3 },
                    { text: 'Master\'s', value: 4 },
                    { text: 'Doctoral', value: 5 }
                ],
				languages: [
                    { text: 'Second language', value: 0 },
                    { text: 'First language', value: 1 }
                ],
				testOptions: [
                    { text: 'No', value: 0 },
                    { text: 'Yes', value: 1 }
                ],
				disableAutotakeOptions: [
                    { text: 'No', value: 0 },
                    { text: 'Yes', value: 1 }
                ],
				disableEditingOptions: [
                    { text: 'No', value: 0 },
                    { text: 'Yes', value: 1 }
                ],
				statusOptions: [
					{ text: 'Banned', value: 0 },
					{ text: 'Active', value: 1 }
				],

                customerUpdateRoute: '/customer/dashboard/profile/update',

                loading: true,
                errors: false,

            }
        },

        validations: {
            name: {
                required,
                minLength: minLength(4)
            },
            email: {
                required,
                email
            },
			major: {
                maxLength: maxLength(100)
			},
			degree: {
                required: requiredIf('personIsCustomer'),
            },
			language: {
                required: requiredIf('personIsCustomer'),
			},
			comment: {
                maxLength: maxLength(2500)
			},
            comment_from_support_to_writers: {
                maxLength: maxLength(50000)
			},
			currentPassword: {
                required: requiredIf('currentPasswordRequired'),
                minLength: minLength(6)
			},
			newPassword: {
                required: requiredIf('newPasswordConfirmation'),
                minLength: minLength(6)
			},
			newPasswordConfirmation: {
                sameAsPassword: sameAs('newPassword')
			},


        },

        created(){
			this.loading = false;

            this.name = this.person.name;
            this.email = this.person.email;
            if(this.person.profile) {
                this.major = this.person.profile.major ? this.person.profile.major : '';
                this.degree = this.person.profile.degree ? this.person.profile.degree : 2;
                this.language = this.person.profile.first_language;
                this.comment = this.person.profile.comment ? this.person.profile.comment : '';
                this.comment_from_support_to_writers = this.person.profile.comment_from_support_to_writers ? this.person.profile.comment_from_support_to_writers : '';
                this.discount = this.person.profile.discount;
                this.disable_autotake = this.person.profile.disable_autotake;
                this.disable_editing = this.person.profile.disable_editing;
			}
			this.status = this.person.status;
			this.test = this.person.test;

        },

		computed: {
            personIsCustomer() {
                return this.$user.isCustomer()
			},
            currentPasswordRequired() {
                return this.newPassword && this.$user.isCustomer()
			}
 		},

        methods: {

            onFileSelected(event) {
				this.image = event.target.files[0];
				let reader = new FileReader();
                reader.readAsDataURL(this.image);
				reader.onload = event => {
				    this.avatar = event.target.result;
				}

			},

            validate () {
                this.$v.$touch();

                const invalidFields = Object.keys(this.$v.$params).filter(fieldName => this.$v[fieldName].$invalid);
                const invalidField = invalidFields[0];

                if (invalidFields) {

                    if(this.$v.$error) {
                        this.$refs[invalidField].focus()
                    }

                    if (this.person && !this.$v.$error) {
                        this.update();
                    }
                }

			},

			url() {
                //It defines the endpoint. How to update the profile
                if (this.$user.isWriter()) return '';
                if (this.$user.isCustomer() && this.person.role_name === 'customer') return this.customerUpdateRoute;
                if (this.$user.isAdmin() && this.person.role_name === 'customer') return '/admin/customer/'+this.person.id+'/update-profile';
                if (this.$user.isAdmin() && this.person.role_name === 'admin') return '/api/adminprofiles/'+this.person.id;

			},

            update() {
                const config = { headers: { 'Content-Type': 'multipart/form-data' } };

                const formData = new FormData();
                if(this.image) formData.append('avatar', this.image, this.image.name);
                formData.append('major', this.major);
                formData.append('degree', this.degree);
                formData.append('first_language', this.language);
                formData.append('comment', this.comment);
                formData.append('comment_from_support_to_writers', this.comment_from_support_to_writers);

                if(this.$user.isAdmin()) {
                formData.append('name', this.name);
                formData.append('email', this.email);
                formData.append('test', this.test);
                formData.append('status', this.status);
                formData.append('discount', this.discount);
                formData.append('disable_autotake', this.disable_autotake);
                formData.append('disable_editing', this.disable_editing);
                }

                if(this.newPassword) {
                formData.append('current_password', this.currentPassword);
                formData.append('new_password', this.newPassword);
                }



                    this.loading = true;
                axios.post(this.url(), formData, config)
                    .catch(error => {
                        this.errors = error.response.data.errors;
                        this.loading = false;
                        flash('Given data was invalid', 'error');

                    })
                    .then(({data}) => {
                        this.loading = false;
                        this.errors = false;
                        flash('Profile has been updated.');
                    });
            },


        },
    }
</script>